import {type VFC} from 'react';
import {Link} from '../../Analytics/Tagging/index.js';

type Props = {
  text: string;
  link: string;
  taggingLabel?: string;
  journeyEvent?: string;
};

const FooterLink: VFC<Props> = ({
  text,
  link,
  taggingLabel = '',
  journeyEvent = '',
}) => (
  <Link
    href={link}
    journeyEvent={journeyEvent}
    rel='noreferrer noopener'
    taggingLabel={taggingLabel}
    target='_blank'
    underline={false}
    weight='normal'
  >
    {text}
  </Link>
);

export default FooterLink;
